import { useEffect, useState } from "react";
import { Parameter } from "../../types/Parameter";
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import {
  DateTimePickerComponent,
  Inject,
} from "@syncfusion/ej2-react-calendars";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { StyledParametersContainer } from "./ParametersContainer.styles";
import { Container, Row } from "react-grid-system";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  Grid,
  GridComponent,
  Resize,
} from "@syncfusion/ej2-react-grids";

interface IParametersContainer {
  title: string;
  jobNumber: string;
  onValidate?: (failed: boolean, value?: any) => void;
  parameters: Parameter[];
}

export const ParametersContainer: React.FC<IParametersContainer> = ({
  title,
  jobNumber,
  onValidate,
  parameters,
}: IParametersContainer) => {
  const [params, setParams] = useState<Parameter[]>(parameters);
  const [errors, setErrors] = useState("");

  let grid: GridComponent | null;

  useEffect(() => {
    if (params) {
      validate(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = (parameters: Parameter[] | undefined) => {
    console.log(`onValidate  ${JSON.stringify(parameters)}`);
    if (
      parameters?.some(
        (parameter) => parameter.value === undefined || parameter.value === null
      )
    ) {
      setErrors("Please enter all parameters.");
      onValidate?.(true, []);
    } else {
      setErrors("");
      onValidate?.(false, parameters);
    }
  };

  const gridTemplate = (props: any): any => {
    return (
      <div>
        {props.type === "string" ? (
          <input
            id={props.value}
            defaultValue={props.value}
            className="custemp"
            type="text"
          />
        ) : (
          <></>
        )}
        {props.type === "number" ? (
          <input
            id={props.value}
            defaultValue={props.value}
            className="custemp"
            type="number"
          />
        ) : (
          <></>
        )}
        {props.type === "dateTime" ? (
          <input
            id={props.value}
            defaultValue={props.value}
            className="custemp"
            type="datetime-local"
          />
        ) : (
          <></>
        )}
      </div>
    );
  };

  const ConditionTemplate = (props: any) => {
    const [text, setText] = useState<string>();
    return (
      <div>
        {props.type === "string" ? (
          <TextBoxComponent
            id="checkTest"
            value={props.value}
            onChange={(args: any) => {
              setText(args.value);
            }}
            onBlur={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.name === props.name) {
                    parameter.value = text;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
        {props.type === "number" ? (
          <NumericTextBoxComponent
            id="checkTest"
            value={props.value}
            onChange={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.name === props.name) {
                    parameter.value = args.value;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
        {props.type === "dateTime" ? (
          <DateTimePickerComponent
            id="dateTime"
            value={props.value}
            onChange={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.name === props.name) {
                    parameter.value = args.value;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
        {props.type === "boolean" ? (
          <CheckBoxComponent
            id="checkTest"
            checked={props.value === true}
            onChange={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.displayName === props.displayName) {
                    parameter.value = args.target.checked;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
      </div>
    );
  };

  return (
    <StyledParametersContainer>
      <Container fluid>
        <Row align="stretch">
          <GridComponent
            dataSource={params}
            id="GridCheckList"
            //allowPaging={true}
            allowResizing={true}
            gridLines="Both"
            ref={(g: GridComponent) => (grid = g)}
            //editSettings={editSettings}
            //load={load}
            //actionComplete={onActionComplete}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="displayName"
                headerText="Info"
                type="string"
                isPrimaryKey={true}
              />
              <ColumnDirective
                field="value"
                headerText="Value"
                //template={gridTemplate}
                template={ConditionTemplate}
              />
            </ColumnsDirective>
            <Inject services={[Edit, Resize]} />
          </GridComponent>
        </Row>
        <Row align="stretch">
          <h6 style={{ color: "red" }}>{errors}</h6>
        </Row>
      </Container>
    </StyledParametersContainer>
  );
};
